import { Box, Typography, Divider, Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDataIaStyles } from "../styles/data-artificial-intelligence";
import TitleForm from "../../common/components/titleform";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import colors from "../../common/styles/colors";
import SheAiService from "../../services/SheAiService";
import loading from "../../assets/images/load-status.gif";
import LoaderHiplade from "../../common/components/loaderhiplade";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { ResponsiveRadar } from "@nivo/radar";

import { Alert, AlertTitle } from '@mui/lab';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

import CircularProgress from '@material-ui/core/CircularProgress'
import { useSocket } from "../../services/hooks/socketHook";
//import DebriefingVideo from "../debriefing-video/DebriefingVideo";
import DebriefingService from "../../services/DebriefingService";
import { useTranslation } from "react-i18next"
import { SheAiVideoProvider, useSheAiVideo } from '../../contexts/SheAiVideoContext';
import SttModule from "./modules/SttModule";
import FexModule from "./modules/FexModule";

function DataIa({ idEvaluated, idDebriefing, faceRecognition = null }: any) {
  const styles = useDataIaStyles();
  const { t } = useTranslation()
  const [status, setStatus] = useState("");
  const [graph, setGraph] = useState<any[]>([]);
  const [keys, setKeys] = useState<any[]>([]);
  const [loader, setLoader] = useState(false); // Loader global
  const [errorSheAi, setErrorSheAi] = useState(false);
  const [showResult, setShowResult] = useState(false);

  // Substitui estados locais pelos do contexto
  const {
    video, setVideo,
    videoId, setVideoId,
    arrVideo, setArrVideo,
    cameraMain, setCameraMain
  } = useSheAiVideo();

  const loadDebriefingUrl = async (debriefingId: any) => {
    await DebriefingService.getDebriefingUrl(debriefingId)
      .then((response: any) => {
        //console.log("Response debriefing URL:", response);
        if (response) {
          if (response.data.length > 0
            //  &&
            // response.data[0].field_name != "debriefing_video"
          ) {
            setVideo(response.data[0]?.recording_url);
            setVideoId(response.data[0]?.streaming_id);
            const cameraDefault = response.data[0]?.camera_main ? true : false;
            setCameraMain(cameraDefault);
            setArrVideo(response.data);
          } else {
            setVideo(response.data[0]?.static_url);
            setVideoId(response.data[0]?.id);
            setCameraMain(true);
          }
        }
      })
      .catch((e: Error) => {});
  };

  useEffect(() => {
    if (idDebriefing) {
      loadDebriefingUrl(idDebriefing);
    }
  }, [idEvaluated, idDebriefing]);

  return (
    <Box className={styles.containerIa}>
      {/* Loader global para qualquer operação dos módulos */}
      {loader && <LoaderHiplade />}
      {/* Debug: Impressão de todas as constantes do arquivo */}
      {/* <Box sx={{ mb: 2, p: 2, background: '#f5f5f5', borderRadius: 2 }}>
        <Typography variant="body2" color="textSecondary">
          <strong>DEBUG:</strong> <br />
          status: {JSON.stringify(status)}<br />
          graph: {JSON.stringify(graph)}<br />
          keys: {JSON.stringify(keys)}<br />
          loader: {JSON.stringify(loader)}<br />
          errorSheAi: {JSON.stringify(errorSheAi)}<br />
          showResult: {JSON.stringify(showResult)}<br />
          video: {JSON.stringify(video)}<br />
          videoId: {JSON.stringify(videoId)}<br />
          arrVideo: {JSON.stringify(arrVideo)}<br />
          cameraMain: {JSON.stringify(cameraMain)}<br />
          idEvaluated: {JSON.stringify(idEvaluated)}<br />
          idDebriefing: {JSON.stringify(idDebriefing)}<br />
          faceRecognition: {JSON.stringify(faceRecognition)}<br />
        </Typography>
      </Box> */}
      <Box>
        <FexModule
          status={status}
          styles={styles}
          video={video}
          videoId={videoId}
          arrVideo={arrVideo}
          setVideo={setVideo}
          setVideoId={setVideoId}
          cameraMain={cameraMain}
          setCameraMain={setCameraMain}
          setLoader={setLoader}
          idEvaluated={idEvaluated}
          idDebriefing={idDebriefing}
          faceRecognition={faceRecognition}
        />
        {/* Módulo STT (Speech to Text) */}
        <SttModule
          debriefingId={idDebriefing}
          evaluatedId={idEvaluated}
          styles={styles}
          setLoader={setLoader} // novo prop
          video={video}
          videoId={videoId}
          arrVideo={arrVideo}
          cameraMain={cameraMain}
        />
      </Box>
    </Box>
  );
}

// Envolva o componente DataIa com o provider para garantir que o contexto de vídeo esteja disponível
// Isso permite que todos os módulos SHEAI acessem video, videoId, arrVideo e cameraMain de forma centralizada
const DataIaWithProvider = (props: any) => (
  <SheAiVideoProvider>
    <DataIa {...props} />
  </SheAiVideoProvider>
);

export default DataIaWithProvider;
